<aside class="admin-sidebar" [class.sidebar-closed]="!state.sidebarOpen()">

  <!-- Logo / Brand -->
  <div class="flex items-center gap-3 px-5 flex-shrink-0"
       style="height: 64px; border-bottom: 1px solid rgba(255,255,255,0.1);">
    <img src="../../../../../../assets/template2/logo.png" alt="Afrilink" class="h-9 w-auto">
    <span class="text-white font-bold text-base tracking-wide">AFRILINK</span>
  </div>

  <!-- Scrollable menu -->
  <nav class="flex-1 overflow-y-auto py-3">

    <!-- Regular role menu -->
    @if (role !== 'Super Admin') {
      @for (item of menu; let i = $index; track i) {

        <!-- Section title -->
        @if (item.isTitle && canShow(item.tags)) {
          <div class="px-4 pt-5 pb-1.5">
            <span class="text-xs font-bold uppercase tracking-widest"
                  style="color: #FAB818; opacity: 0.85;">{{ item.title }}</span>
          </div>
        }

        <!-- Simple link -->
        @if (!item.isTitle && !item.hasChildren && canShow(item.tags)) {
          <div class="px-3 py-0.5">
            <a [routerLink]="item.route"
               (click)="onLinkClick()"
               routerLinkActive="sidebar-link-active"
               class="sidebar-link flex items-center gap-3 px-3 py-2.5 rounded-lg">
              <span class="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0"></span>
              <span class="text-sm">{{ item.name }}</span>
            </a>
          </div>
        }

        <!-- Link with children -->
        @if (!item.isTitle && item.hasChildren && canShow(item.tags)) {
          <div class="px-3 py-0.5">
            <button (click)="toggleMenu(i)"
                    class="sidebar-link w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left border-0">
              <span class="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0"></span>
              <span class="text-sm flex-1">{{ item.name }}</span>
              <svg class="w-4 h-4 flex-shrink-0 transition-transform duration-200"
                   [class.rotate-180]="openedMenus[i]"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </button>

            @if (openedMenus[i]) {
              <div class="pl-4 pt-0.5 pb-1">
                @for (child of item.children; track child.route) {
                  @if (canShow(child.tags)) {
                    <a [routerLink]="child.route"
                       (click)="onLinkClick()"
                       routerLinkActive="sidebar-link-active"
                       class="sidebar-link-sub flex items-center gap-2.5 px-3 py-2 rounded-lg">
                      <span class="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
                      <span class="text-sm">{{ child.name }}</span>
                    </a>
                  }
                }
              </div>
            }
          </div>
        }

      }
    }

    <!-- Super Admin menu -->
    @if (role === 'Super Admin') {
      <div class="px-4 pt-5 pb-1.5">
        <span class="text-xs font-bold uppercase tracking-widest" style="color: #FAB818; opacity: 0.85;">Paramètres</span>
      </div>

      <div class="px-3 py-0.5">
        <button (click)="toggleMenu(0)"
                class="sidebar-link w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left border-0">
          <span class="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0"></span>
          <span class="text-sm flex-1">Administrateur</span>
          <svg class="w-4 h-4 transition-transform duration-200"
               [class.rotate-180]="openedMenus[0]"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
          </svg>
        </button>
        @if (openedMenus[0]) {
          <div class="pl-4 pt-0.5 pb-1">
            <a routerLink="/users" (click)="onLinkClick()" routerLinkActive="sidebar-link-active" class="sidebar-link-sub flex items-center gap-2.5 px-3 py-2 rounded-lg">
              <span class="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
              <span class="text-sm">Compte Utilisateur</span>
            </a>
            <a routerLink="/roles" (click)="onLinkClick()" routerLinkActive="sidebar-link-active" class="sidebar-link-sub flex items-center gap-2.5 px-3 py-2 rounded-lg">
              <span class="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
              <span class="text-sm">Profils</span>
            </a>
            <a routerLink="/permissions" (click)="onLinkClick()" routerLinkActive="sidebar-link-active" class="sidebar-link-sub flex items-center gap-2.5 px-3 py-2 rounded-lg">
              <span class="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
              <span class="text-sm">Permissions</span>
            </a>
            <a routerLink="/profiles" (click)="onLinkClick()" routerLinkActive="sidebar-link-active" class="sidebar-link-sub flex items-center gap-2.5 px-3 py-2 rounded-lg">
              <span class="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
              <span class="text-sm">Profils et Permissions</span>
            </a>
          </div>
        }
      </div>

      <div class="px-3 py-0.5">
        <a routerLink="/configurations/countries" (click)="onLinkClick()" routerLinkActive="sidebar-link-active"
           class="sidebar-link flex items-center gap-3 px-3 py-2.5 rounded-lg">
          <span class="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0"></span>
          <span class="text-sm">Pays</span>
        </a>
      </div>
    }

  </nav>

  <!-- Bottom info -->
  <div class="flex-shrink-0 px-4 py-3" style="border-top: 1px solid rgba(255,255,255,0.1);">
    <p class="text-xs text-center" style="color: rgba(255,255,255,0.4);">© 2025 Afrilink SAS</p>
  </div>

</aside>
